import * as React from 'react';

import Arrow16 from './Arrow16';

export const arrow16 = () => <Arrow16 />;

export default {
    title: 'Icon|Fill|Arrow16',
    component: Arrow16,
    parameters: {
        notes: "`import Arrow16 from 'box-ui-elements/es/icon/fill/Arrow16';`",
    },
};
